import { useState } from 'react';
import { type AbortPageProps } from '../../../chulak/ChulakSession';
import {
  abortVariantConfig,
  getAbortVariant,
} from '../../../utils/abortVariants';
import EmbeddedErrorScreen from './ErrorScreen';
import EmbeddedStatusScreen from './StatusScreen';
import { useEmbeddedCopy } from '../../../hooks/useEmbeddedCopy';
import EmbeddedWhyScreen from './WhyScreen';

/**
 * EmbeddedAbortScreen — The errors the desktop and phone abort pages share:
 * before an app was chosen, and "didn't finish" with its "Why?" answer. Each
 * page shows an expired request itself.
 */
export default function EmbeddedAbortScreen({
  app,
  errorCode,
  variant: variantProp,
  onRestart,
  onBack,
}: AbortPageProps) {
  const { t } = useEmbeddedCopy();
  const [why, setWhy] = useState(false);
  const variant = variantProp ?? getAbortVariant(errorCode);

  // Before an app was chosen (init and configuration errors) there is no
  // session to retry: say what went wrong and offer nothing.
  if (!app) {
    const config = abortVariantConfig[variant];
    return (
      <EmbeddedStatusScreen
        visual="alert"
        title={t(config.titleKey)}
        sub={t(config.subtitleKey)}
      />
    );
  }

  if (why) return <EmbeddedWhyScreen app={app} onBack={() => setWhy(false)} />;

  return (
    <EmbeddedErrorScreen
      app={app}
      onRetry={onRestart}
      onBack={onBack}
      onWhy={() => setWhy(true)}
    />
  );
}
